// extracted by mini-css-extract-plugin
export default {"addressSection":"LP-z","disabled":"MP-z","sectionButtons":"NP-z","logo":"OP-z"};